import { cn } from "@/modules/lib/utils"
import { ProfileAvatar } from "@modules/profile/common/components/profileAvatar"

type ChatAvatarProps = {
  image?: string
  name?: string
  isOnline?: boolean
  profileAvatarClassName?: string
}

export const ChatAvatar: React.FC<ChatAvatarProps> = ({ image, name, isOnline, profileAvatarClassName }) => {
  return (
    <div className="relative">
      <ProfileAvatar
        profile={{ avatar: image ? { url: image, hash: "" } : null, username: name ?? "A" }}
        className={cn("size-5", profileAvatarClassName)}
      />
      {isOnline && <div className="absolute top-[-2px] right-[-2px] h-2.5 w-2.5 rounded-xl bg-custom-green-500" />}
    </div>
  )
}
